<template>
  <imgix-image
    :sizes="sizes"
    :imgixParams="imgixParamsWithAdditional"
    :path="path"
    :alt="alt"
    :style="{ width: '100%', height: 'auto' }"
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
  />
</template>

<script>
import { SELLERS_IMAGE_PATH } from "@/config/imgix.js";
import { defineAsyncComponent } from "vue";
const ImgixImage = defineAsyncComponent(() => import("@/components/imgix-image.vue"));

export default {
  components: {
    ImgixImage,
  },

  props: {
    alt: {
      type: String,
      default: "Product Image",
    },

    imgixParams: {
      type: Object,
      default: () => {},
    },

    name: {
      type: String,
      required: true,
    },

    sizes: {
      type: [String],
      default: "100vw",
    },
  },

  computed: {
    path() {
      let imagePath = "image";

      return imagePath;
    },

    imgixParamsWithAdditional() {
      let params = { ...this.imgixParams };

      params.path = `${SELLERS_IMAGE_PATH}${this.name}`;

      return params;
    },
  },
};
</script>
